import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const config = {
  state: {
    userModule: {
      isLogin: false,
      clientId: "",
      email: null,
      filePath: "",
      fileUrl: "",
      id: "",
      loginName: "",
      mobile: "",
      nickName: null,
      password: "",
      permissions: null,
      roles: [],
      sessionId: "",
      sex: null,
      token: "",
      userName: null,
      invalid: 0
    }

  },
  getters: {
    userModule: state => state
  },
  mutations: {
    invalidLogin(state, v) {
      state.userModule.isLogin = false
      state.userModule.invalid = state.userModule.invalid + 1
      state.userModule.email = null
      state.userModule.filePath = "../../static/img/morenP.png"
      state.userModule.id = ''
      state.userModule.loginName = ''
      state.userModule.mobile = ''
      state.userModule.nickName = null
      state.userModule.password = ''
      state.userModule.permissions = null
      state.userModule.roles = []
      state.userModule.sessionId = ''
      state.userModule.sex = null
      state.userModule.userName = null
    },
    saveUser(state, v) {
      state.userModule.isLogin = v.isLogin
      state.userModule.email = v.email
      state.userModule.filePath = v.filePath
      state.userModule.id = v.id
      state.userModule.loginName = v.loginName
      state.userModule.mobile = v.mobile
      state.userModule.nickName = v.nickName
      state.userModule.password = v.password
      state.userModule.permissions = v.permissions
      state.userModule.roles = v.roles
      state.userModule.sessionId = v.sessionId
      state.userModule.sex = v.sex
      state.userModule.userName = v.userName
      state.userModule.invalid = 0
    },
    saveBase(state, v) {
      state.userModule.clientId = v.clientId;
      state.userModule.fileUrl = v.fileUrl;
      state.userModule.token = v.token;
      state.userModule.csCloudClassMobileUrl = v.csCloudClassMobileUrl;
    }
  }

}

export default new Vuex.Store(config);



// WEBPACK FOOTER //
// ./src/store/index.js